import { Component, EventEmitter, Input, OnInit, Output } from '@angular/core';
import { ProductoDesembolso } from '../../../_models/producto-desembolso';
import { Router } from '@angular/router';

@Component( {
  selector: 'app-producto-desembolso-detalle',
  templateUrl: 'producto-desembolso-detalle.component.html'
} )
export class ProductoDesembolsoDetalleComponent implements OnInit {


  @Input() productoDesembolso: ProductoDesembolso;
  @Output() dismiss: EventEmitter<boolean> = new EventEmitter();

  constructor(
    private router: Router
  ) {
  }

  ngOnInit(): void {
  }

  regresar() {
    this.dismiss.emit(false);
  }



}
